function waitForVariantId(retries = 20, interval = 300) {
  return new Promise((resolve, reject) => {
    const check = () => {
      const variantId =
        document.querySelector('input[name="id"]')?.value ||
        document.querySelector('select[name="id"]')?.value;

      if (variantId) {
        resolve(variantId);
      } else if (retries <= 0) {
        reject('❌ ID prodotto o variante non disponibile dopo il timeout.');
      } else {
        setTimeout(() => {
          retries--;
          check();
        }, interval);
      }
    };
    check();
  });
}

document.addEventListener('DOMContentLoaded', async () => {
  try {
    const variantId = await waitForVariantId();

    const response = await fetch(`/omnibus/variant/${variantId}`);
    if (!response.ok) throw new Error('Errore nella risposta');

    const data = await response.json();

    if (data && data.min_price_last_30_days) {
      const prezzo = parseFloat(data.min_price_last_30_days).toFixed(2);
      const container = document.createElement('div');
      container.className = 'lowest-price-30gg';
      container.innerText = `💶 Prezzo più basso degli ultimi 30 giorni: €${prezzo}`;

      const form = document.querySelector('form[action^="/cart/add"]');
      if (form) {
        form.parentNode.insertBefore(container, form.nextSibling);
      } else {
        document.body.appendChild(container);
      }
    } else {
      console.warn('❌ Nessun dato disponibile per il prezzo minimo.');
    }
  } catch (err) {
    console.error(err);
  }
});

